import type { VariantDotBadge } from "@/components/shared/dot-badge";
import {
	appointmentBadgeClass,
	appointmentDotVariant,
} from "@/lib/appointments/status-styles";
import type { Appointment } from "@/types/admin-portal/appointment";

// Thin wrappers kept for backwards-compatible call sites. The actual palette
// lives in lib/appointments/status-styles.ts (single source of truth).

export const getBadgeVariantStatus = (status: Appointment["status"]): string =>
	appointmentBadgeClass(status);

export const getDotVariantStatus = (
	status: Appointment["status"],
): VariantDotBadge["variant"] => appointmentDotVariant(status);
